import AngularIcon from "../components/icons/Angular";
import JavascriptIcon from "../components/icons/Javascript";
import NodeIcon from "../components/icons/Node";
import ReactIcon from "../components/icons/React";
import DbIcon from "../components/icons/DB";
import ThreeIcon from "../components/icons/Three";
import TypescriptIcon from "../components/icons/Typescript";
import VueIcon from "../components/icons/Vue";
import RPAIcon from "../components/icons/RPA";
import NextIcon from "../components/icons/Nextjs";
import AstroIcon from "../components/icons/Astro";
import NestJsIcon from "../components/icons/NestJS";
import ExpressIcon from "../components/icons/Express";
import WebIcon from "../components/icons/Web";
import AwsIcon from "../components/icons/Aws";
import DockerIcon from "../components/icons/Docker";

export const booksInfo = {
  react: {
    title: "React",
    color: "#61DBFB",
    logo: <ReactIcon fill="#666666" rotation="10" />,
    overview: [
      { title: "library.content.level", value: 5 },
      { title: "library.content.affinity", value: 5 },
    ],
    sections: [
      {
        title: "library.content.libraries",
        items: [
          { name: "React Router", url: "https://reactrouter.com/" },
          { name: "Redux", url: "https://redux.js.org/" },
          {
            name: "Zustand",
            url: "https://docs.pmnd.rs/zustand/getting-started/introduction",
          },
          {
            name: "Fiber",
            url: "https://docs.pmnd.rs/react-three-fiber/getting-started/introduction",
          },
          { name: "Styled Components", url: "https://styled-components.com/" },
          {
            name: "CSS Modules",
            url: "https://github.com/css-modules/css-modules",
          },
          { name: "Tailwind", url: "https://tailwindcss.com/" },
          { name: "Emotion", url: "https://emotion.sh/docs/introduction" },
        ],
      },
      {
        title: "library.content.frameworks",
        items: [
          { name: "NextJS", url: "https://nextjs.org" },
          { name: "Astro", url: "https://astro.build" },
        ],
      },
    ],
    relatedContent: ["angular", "vue", "astro"],
  },
  angular: {
    title: "Angular",
    color: "#DE002D",
    logo: <AngularIcon fill="#6666664D" rotation="10" />,
    overview: [
      { title: "library.content.level", value: 4 },
      { title: "library.content.affinity", value: 4 },
    ],
    sections: [],
    relatedContent: ["react", "vue"],
  },
  vue: {
    title: "Vue",
    color: "#81C784",
    logo: <VueIcon fill="#666666" rotation="10" />,
    overview: [
      { title: "library.content.level", value: 4 },
      { title: "library.content.affinity", value: 4 },
    ],
    sections: [
      {
        title: "library.content.frameworks",
        items: [{ name: "NuxtJS", url: "https://nuxtjs.org" }],
      },
    ],
    relatedContent: ["react", "angular", "astro"],
  },
  astro: {
    title: "Astro",
    color: "#981dc4",
    logo: <AstroIcon fill="#6666664D" rotation="10" />,
    overview: [
      { title: "library.content.level", value: 3 },
      { title: "library.content.affinity", value: 5 },
    ],
    sections: [],
    relatedContent: ["react", "vue"],
  },
  threejs: {
    title: "Threejs",
    color: "#d6ab5a",
    logo: <ThreeIcon fill="#666666" />,
    overview: [
      { title: "library.content.level", value: 4 },
      { title: "library.content.affinity", value: 5 },
    ],
    sections: [
      {
        title: "library.content.libraries",
        items: [
          {
            name: "Fiber",
            url: "https://docs.pmnd.rs/react-three-fiber/getting-started/introduction",
          },
          {
            name: "Cannon",
            url: "https://schteppe.github.io/cannon.js/",
          },
        ],
      },
    ],
    relatedContent: ["react"],
  },
  typescript: {
    title: "Typescript",
    color: "#00aee3",
    logo: <TypescriptIcon fill="#6666664D" rotation="10" />,
    overview: [
      { title: "library.content.level", value: 4 },
      { title: "library.content.affinity", value: 5 },
    ],
    sections: [],
    relatedContent: ["angular", "nest", "react"],
  },
  next: {
    title: "Next.js",
    color: "#6b7287",
    logo: <NextIcon fill="#6666664D" />,
    overview: [
      { title: "library.content.level", value: 5 },
      { title: "library.content.affinity", value: 5 },
    ],
    sections: [],
    relatedContent: ["react"],
  },
  javascript: {
    title: "Javascript",
    color: "#ffd000",
    logo: <JavascriptIcon fill="#6666664D" rotation="10" />,
    overview: [
      { title: "library.content.level", value: 5 },
      { title: "library.content.affinity", value: 5 },
    ],
    sections: [
      {
        title: "library.content.libraries",
        items: [
          { name: "axios", url: "https://axios-http.com" },
          { name: "lodash", url: "https://lodash.com" },
          { name: "gsap", url: "https://greensock.com/gsap" },
          { name: "mongoose", url: "https://mongoosejs.com" },
          { name: "threejs", url: "https://threejs.org" },
          { name: "web3js", url: "https://web3js.readthedocs.io" },
        ],
      },
      {
        title: "library.content.frameworks",
        items: [
          { name: "React", url: "https://reactjs.org" },
          { name: "Angular", url: "https://angular.io" },
          { name: "Vue", url: "https://vuejs.org" },
          { name: "Node", url: "https://nodejs.org" },
        ],
      },
    ],
    relatedContent: ["react", "angular", "vue"],
  },
  nodejs: {
    title: "Node",
    color: "#21A366",
    logo: <NodeIcon fill="#6666664D" rotation="10" />,
    overview: [
      { title: "library.content.level", value: 4 },
      { title: "library.content.affinity", value: 5 },
    ],
    sections: [
      {
        title: "library.content.frameworks",
        items: [
          {
            name: "Express",
            url: "https://expressjs.com",
          },
          {
            name: "Nest",
            url: "https://nestjs.com",
          },
        ],
      },
    ],
    relatedContent: ["javascript", "typescript"],
  },
  express: {
    title: "Express",
    color: "#FFD842",
    logo: <ExpressIcon fill="#6666664D" rotation="10" />,
    overview: [
      { title: "library.content.level", value: 4 },
      { title: "library.content.affinity", value: 4 },
    ],
    sections: [],
    relatedContent: ["nodejs"],
  },
  nest: {
    title: "NestJS",
    color: "#ED2025",
    logo: <NestJsIcon fill="#6666664D" rotation="30" flip />,
    overview: [
      { title: "library.content.level", value: 3 },
      { title: "library.content.affinity", value: 5 },
    ],
    sections: [],
    relatedContent: ["javascript", "typescript"],
  },
  sql: {
    title: "SQL",
    color: "#00aee3",
    logo: <DbIcon fill="#6666664D" rotation="10" />,
    overview: [
      { title: "library.content.level", value: 4 },
      { title: "library.content.affinity", value: 5 },
    ],
    sections: [
      {
        title: "library.content.databases",
        items: [
          {
            name: "PostgreSQL",
            url: "https://www.postgresql.org",
          },
          {
            name: "MySQL",
            url: "https://www.mysql.com",
          },
          {
            name: "SQLite",
            url: "https://sqlite.org",
          },
          {
            name: "MariaDB",
            url: "https://mariadb.org",
          },
        ],
      },
      {
        title: "library.content.orms",
        items: [
          {
            name: "TypeORM",
            url: "https://typeorm.io",
          },
          {
            name: "Sequelize",
            url: "https://sequelize.org",
          },
          {
            name: "Prisma",
            url: "https://www.prisma.io",
          },
          {
            name: "Prisma",
            url: "https://orm.drizzle.team/",
          },
        ],
      },
    ],
    relatedContent: ["no sql"],
  },
  "no sql": {
    title: "No SQL",
    color: "#a442f5",
    logo: <DbIcon fill="#6666664D" rotation="10" />,
    overview: [
      { title: "library.content.level", value: 4 },
      { title: "library.content.affinity", value: 5 },
    ],
    sections: [
      {
        title: "library.content.databases",
        items: [
          {
            name: "MongoDB",
            url: "https://www.mongodb.com",
          },
          {
            name: "DynamoDB",
            url: "https://aws.amazon.com/es/dynamodb",
          },
        ],
      },
      {
        title: "library.content.orms",
        items: [
          {
            name: "Mongoose",
            url: "https://mongoosejs.com",
          },
        ],
      },
    ],
    relatedContent: ["sql"],
  },
  web3: {
    title: "Web3",
    color: "#3fab9d",
    logo: <WebIcon fill="#6666664D" rotation="10" />,
    overview: [
      { title: "library.content.level", value: 3 },
      { title: "library.content.affinity", value: 3 },
    ],
    sections: [
      {
        title: "library.content.libraries",
        items: [
          { name: "web3js", url: "https://web3js.org/" },
          {
            name: "ethers.js",
            url: "https://docs.ethers.org/v5/",
          },
        ],
      },
    ],
    relatedContent: ["typescript"],
  },
  aws: {
    title: "AWS",
    color: "#d69147",
    logo: <AwsIcon fill="#6666664D" rotation="5" />,
    overview: [
      { title: "library.content.level", value: 3 },
      { title: "library.content.affinity", value: 4 },
    ],
    sections: [
      {
        title: "library.content.services",
        items: [{ name: "s3", url: "https://aws.amazon.com/pm/serv-s3/" }],
      },
    ],
    relatedContent: ["docker"],
  },
  docker: {
    title: "Docker",
    color: "#1C90ED",
    logo: <DockerIcon fill="#6666664D" rotation="10" />,
    overview: [
      { title: "library.content.level", value: 3 },
      { title: "library.content.affinity", value: 4 },
    ],
    sections: [],
    relatedContent: ["aws"],
  },
  rpa: {
    title: "RPA",
    color: "#9636bf",
    logo: <RPAIcon fill="#6666664D" rotation="10" />,
    overview: [
      { title: "library.content.level", value: 3 },
      { title: "library.content.affinity", value: 3 },
    ],
    sections: [
      {
        title: "UiPath",
        items: [
          { name: "Studio", url: "https://www.uipath.com/es/product/studio" },
          {
            name: "Orchestrator",
            url: "https://www.uipath.com/es/product/orchestrator",
          },
        ],
      },
    ],
    relatedContent: [],
  },
};
